export default __webpack_public_path__ + "static/media/back.69501b5f.svg";